module.exports = __webpack_public_path__ + "static/media/nav-icon-okr-inactive.6c40451c.svg";